import styled from 'styled-components';

export const NoItemsAvailable = styled.span`
  font-size: 1.4rem;
  display: block;
  padding: 2rem;
  color: ${p => p.theme.textColor};
`;
